<template>
  <div class="mt-4">
    <p class="p-sm text--gray-darken1">Additional Services</p>
    <div class="additional-services-list">
      <ul>
        <li class="d-flex align-center p-sm text--darken1">
          PanelAlpha Global DNS
          <v-tooltip open-delay="150" bottom transition="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="cursor-pointer ml-2"
                v-on="on"
                v-bind="attrs"
                size="11"
                >$infoCircle</v-icon
              >
            </template>
            <div>
              <p class="p-3 mb-0">
                {{ $t("PLAN INFO") }}
              </p>
            </div>
          </v-tooltip>
          <CustomLabel :class="'xs'" :type="'free'" class="ml-4"
            >Free</CustomLabel
          >
        </li>
        <li class="d-flex align-center p-sm text--darken1">
          PanelAlpha Protection
          <v-tooltip open-delay="150" bottom transition="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="cursor-pointer ml-2"
                v-on="on"
                v-bind="attrs"
                size="11"
                >$infoCircle</v-icon
              >
            </template>
            <div>
              <p class="p-3 mb-0">
                {{ $t("PLAN INFO") }}
              </p>
            </div>
          </v-tooltip>
          <CustomLabel :class="'xs'" :type="'premium'" class="ml-4"
            >Premium</CustomLabel
          >
        </li>
        <li class="d-flex align-center p-sm text--darken1">
          Anti-Malware Protection
          <v-tooltip open-delay="150" bottom transition="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="cursor-pointer ml-2"
                v-on="on"
                v-bind="attrs"
                size="11"
                >$infoCircle</v-icon
              >
            </template>
            <div>
              <p class="p-3 mb-0">
                {{ $t("PLAN INFO") }}
              </p>
            </div>
          </v-tooltip>
          <CustomLabel :class="'xs'" :type="'disabled'" class="ml-4"
            >Disabled</CustomLabel
          >
        </li>
        <li class="d-flex align-center p-sm text--darken1">
          SEO Analytics
          <v-tooltip open-delay="150" bottom transition="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="cursor-pointer ml-2"
                v-on="on"
                v-bind="attrs"
                size="11"
                >$infoCircle</v-icon
              >
            </template>
            <div>
              <p class="p-3 mb-0">
                {{ $t("PLAN INFO") }}
              </p>
            </div>
          </v-tooltip>
          <CustomLabel :class="'xs'" :type="'free'" class="ml-4"
            >Free</CustomLabel
          >
        </li>
        <li class="d-flex align-center p-sm text--darken1">
          PanelAlpha Global DNS
          <v-tooltip open-delay="150" bottom transition="custom-tooltip">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="cursor-pointer ml-2"
                v-on="on"
                v-bind="attrs"
                size="11"
                >$infoCircle</v-icon
              >
            </template>
            <div>
              <p class="p-3 mb-0">
                {{ $t("PLAN INFO") }}
              </p>
            </div>
          </v-tooltip>
          <CustomLabel :class="'xs'" :type="'premium'" class="ml-4"
            >Premium</CustomLabel
          >
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import CustomLabel from "../../labels/CustomLabel.vue";

export default {
  components: {
    CustomLabel,
  },
};
</script>